import queryString from 'qs';

export function formatSearchParams(paramsMap) {
  let mappedParams = [];

  if (Object.values(paramsMap).length) {
    mappedParams = Object.keys(paramsMap).reduce((acc, key) => {
      if (key === 'catalogs') {
        acc.push(
          `${key}=${Array.from(paramsMap[key]).map(str => encodeURIComponent(str))}`.replace(
            /,/g,
            encodeURIComponent(';,')
          )
        );
      } else {
        acc.push(`${key}=${Array.from(paramsMap[key])}`);
      }

      return acc;
    }, []);

    return mappedParams.length > 0 ? `&${mappedParams.join('&')}` : '';
  }

  return mappedParams;
}

export function formatPriceRange(map) {
  let mappedPriceRange = '';

  [...map].map(item => {
    mappedPriceRange += `&${item[0]}=${item[1]}`;

    return null;
  });

  return mappedPriceRange;
}

export function formatFacetParams(selectedFacets) {
  return Object.keys(selectedFacets).length ? `&${queryString.stringify(selectedFacets)}` : '';
}
